import { OptionMenuItem } from 'src/components/ui/OptionMenu';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';

interface Props {
    onClick: () => void;
}

export function ExportVisitsButton({ onClick }: Props) {
    return (
        <OptionMenuItem onClick={onClick}>
            <InsertDriveFileRoundedIcon sx={{ height: 20, width: 20 }}/>
            <p className="text-sm font-semibold text-center">Exportar visitas a excel</p>
        </OptionMenuItem>
    );
}
